import React, { useContext } from "react";
import styled from "styled-components";

import * as colors from "../../styles/colors";
import { parseMarkdownLinks } from "./parseMarkdownLinks";
import { CrownPriceContext } from "./MdxProvider";

const Figure = styled.figure`
  margin: 28px auto;
  padding: 0;
  max-width: ${(props) => props.$maxWidth || "560px"};
  width: 100%;

  @media (max-width: 640px) {
    margin: 20px auto;
  }
`;

const ImageCard = styled.div`
  background: ${(props) => props.$background || "#ffffff"};
  border-radius: 12px;
  padding: 16px;
  box-sizing: border-box;
  line-height: 0;

  @media (max-width: 640px) {
    padding: 10px;
    border-radius: 8px;
  }
`;

const ImageLink = styled.a`
  display: block;
  line-height: 0;
`;

const Img = styled.img`
  width: 100%;
  height: auto;
  display: block;
  margin: 0;
`;

const Caption = styled.figcaption`
  margin-top: 12px;
  padding: 0 4px;
  font-size: 14px;
  line-height: 1.6;
  color: ${colors.muted};
  text-align: center;
  font-style: italic;

  a {
    color: ${colors.muted};
    text-decoration: underline;
  }

  @media (max-width: 640px) {
    font-size: 13px;
    text-align: left;
    margin-top: 10px;
    padding: 0;
  }
`;

export function GuideImage({
  src,
  alt,
  href,
  caption,
  maxWidth,
  background,
}) {
  const crownPrice = useContext(CrownPriceContext);
  const img = <Img src={src} alt={alt || ""} loading="lazy" />;

  return (
    <Figure $maxWidth={maxWidth}>
      <ImageCard $background={background}>
        {href ? (
          <ImageLink href={href} target="_blank" rel="nofollow noreferrer">
            {img}
          </ImageLink>
        ) : (
          img
        )}
      </ImageCard>
      {caption && (
        <Caption>{parseMarkdownLinks(caption, { crownPrice })}</Caption>
      )}
    </Figure>
  );
}
